// ----------------------------------------------------------------------
import Table from './Table';

export default function ComponentsOverrides(theme) {
  return Object.assign(Table(theme));
}
